import type { IconSvgObject } from './types';

const SeesawIcon: IconSvgObject = [
  ["path", { d: "M8 18H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 18V13M10.5 14V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.9142 6.63204L17.3237 6.31602M17.3237 6.31602L18.7332 6M17.3237 6.31602L17.9745 9.05369M3.69837 9.37089L5.10788 9.05487M5.10788 9.05487L6.51739 8.73885M5.10788 9.05487L5.7587 11.7925M2 12.6353L21.7332 8.21097L21.9501 9.12353C22.1898 10.1315 21.5426 11.1373 20.5047 11.37L4.53018 14.9516C3.49224 15.1843 2.45657 14.5558 2.21694 13.5478L2 12.6353Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SeesawIcon;
